import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './index.module.scss';
import moment from 'moment';

let cx = classNames.bind(styles);

const Index = props => {
	const job = props.job;
	useEffect(() => {}, [job]);

	return (
		<div className={cx({ jobItem: true, ' flex flex-col font-HelveticaNeueLTStd-Bold': true })}>
			<div
				className={cx({
					jobDetailTitle: true,
					'p-4 lg:p-8 rounded-t-lg flex flex-col lg:flex-row w-full': true,
				})}
			>
				<div className='flex flex-col lg:w-5/6 text-telus-purple font-HelveticaNeueLTStd-Bold'>
					<strong> {job.name}</strong>
					<span> {job.location}</span>
					<br />
					<small>
						Publicado: {moment(job.start_date).format('DD/MM/YYYY')}
					</small>
				</div>
				<div className='flex flex-col lg:w-1/6 justify-center items-center hidden lg:block'>
					<strong>
						<a
							className={cx({
								jobButton: true,
								'w-full w-full text-telus-purple font-HelveticaNeueLTStd-Bold': true,
							})}
							href={`${process.env.REACT_APP_CLIENT_URL}${job.slug}/postular`}
							rel='noopener noreferrer'
							target='_blank'
						>
							Postular
						</a>
					</strong>
				</div>
			</div>
			<div
				className='job-line bg-gray-200 h-auto lg:p-8 p-4 w-full poferta text-telus-purple'
				dangerouslySetInnerHTML={{
					__html: job.description
						? job.description.replace('style', 'pstyle')
						: '',
				}}
			/>
			<div className={cx({ jobButton: true, ' flex w-full': true })}>
				<a
					className='w-full'
					href={`${process.env.REACT_APP_CLIENT_URL}${job.slug}/postular`}
					rel='noopener noreferrer'
					target='_blank'
				>
					Postular
				</a>
			</div>
		</div>
	);
};

Index.propTypes = {
	job: PropTypes.object.isRequired,
};
export default Index;
